import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=05938ea4&scoped=true&"
import script from "./TicketItem.vue?vue&type=script&lang=js&"
export * from "./TicketItem.vue?vue&type=script&lang=js&"
import style0 from "./TicketItem.vue?vue&type=style&index=0&id=05938ea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05938ea4",
  null
  
)

export default component.exports